import { Box, Button } from "@mui/material";
import React from "react";
import { VisuallyHiddenInput } from "../../styles";
import { isMobile } from "../../utils/functions";
import { url } from "../../utils/url";

const UploadImg = ({ selectedImage, setSelectedImage }) => {
  return (
    <Box sx={{ margin: "100px auto" }}>
      {selectedImage ? (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
          {selectedImage.id ? (
            <img alt="not found" width={isMobile() ? 300 : 600} src={`${url}attached-files/${selectedImage.id}`} />
          ) : (
            <img alt="not found" width={isMobile() ? 300 : 600} src={URL.createObjectURL(selectedImage)} />
          )}
          <Button onClick={() => setSelectedImage(null)}>Премахни</Button>
        </Box>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button component="label" variant="outlined">
            Прикачи снимка
            <VisuallyHiddenInput type="file" accept="image/*" onChange={(e) => setSelectedImage(e.target.files[0])} />
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default UploadImg;
